/* eslint-disable @typescript-eslint/no-unused-vars */

import { Route, Routes, Navigate } from 'react-router-dom'
import Home from '../PublicPages/home'
import { PublicPageLayout } from '../../_theme/layout/PublicPageLayout'
import AboutUs from '../PublicPages/aboutUs'
import ProjectEvaluation from '../PublicPages/projectEvaluation'
import InvestorProspectus from '../PublicPages/investorProspectus'
import GovernanceToolsandMethods from '../PublicPages/GovernanceToolsandMethods'
import CriticalGigamaps from '../PublicPages/criticalGigamaps'
import ArtificialInteligence from '../PublicPages/arificialInteligence'
import ContactUs from '../PublicPages/contactUs'
import WesternCapeInfrastructureStrategy from '../PublicPages/western-cape-infrastructure-strategy'
import WesternCapeInfrastructureFrameWork from '../PublicPages/western-cape-infrastructure-framework'
import WesternCapeInfrastructureImplementationPlan from '../PublicPages/western-cape-infrastructure-implementation-plan'
import Calendar from '../modules/Dashboard/calendar/calender'

const PublicRoutes = () => {
    return (
        <Routes>
            <Route element={<PublicPageLayout />}>

                {/* Home */}
                <Route path="home" element={<Home />} />

                {/* Pages */}
                <Route path="about-us" element={<AboutUs />} />
                <Route path="contact-us" element={<ContactUs />} />
                <Route path="project-evaluation" element={<ProjectEvaluation />} />
                <Route path="investor-prospectus" element={<InvestorProspectus />} />
                <Route path="governance-tools-and-methods" element={<GovernanceToolsandMethods />} />
                <Route path="critical-gigamaps" element={<CriticalGigamaps />} />
                <Route path="artificial-intelligence" element={<ArtificialInteligence />} />
                <Route path="western-cape-infrastructure-strategy" element={<WesternCapeInfrastructureStrategy />} />
                <Route path="western-cape-infrastructure-framework" element={<WesternCapeInfrastructureFrameWork />} />
                <Route path="western-cape-infrastructure-implementation-plan" element={<WesternCapeInfrastructureImplementationPlan />} />
                <Route path="manage-events" element={<Calendar />} />
                {/* 404 inside public section */}
                <Route path="*" element={<Navigate to="/pages/home" />} />

            </Route>
        </Routes>
    );
};

export { PublicRoutes }
